import { MainView } from '@repo/ui/Views';
import { Card } from '@repo/ui/Card';
import { SelectorInputField, type Option } from '@repo/ui/Form';
import SettingsTabNav from '../components/SettingsTabNav';
import { useTheme, type Theme } from '@repo/hooks/useTheme';

const options: Option[] = [
  { label: 'System', value: 'system' },
  { label: 'Light', value: 'light' },
  { label: 'Dark', value: 'dark' },
];

const SettingsAppearance = () => {
  const { theme, setTheme } = useTheme();

  return (
    <MainView title="Settings">
      <SettingsTabNav />
      <Card title="Appearance" description="Select your preferred theme.">
        <SelectorInputField
          key={theme}
          label="Theme"
          options={options}
          value={theme}
          onChange={async (e) => {
            setTheme(e.target.value as Theme);
          }}
          additionalContainerClasses="max-w-md"
        />
      </Card>
    </MainView>
  );
};

export default SettingsAppearance;
